module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.e18bbf6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/bootstrap/fonts/glyphicons-halflings-regular.ttf
// module id = sJTC
// module chunks = 1